import React from 'react';
import { SEO } from '../components/SEO';
import { breadcrumbSchema } from '../utils/structuredData';
import { ArrowLeftIcon } from 'lucide-react';
export function ImpressumPage() {
  const breadcrumbs = [{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Legal Notice',
    url: 'https://close-crm-agentur.de/legal-notice'
  }];
  const structuredData = [breadcrumbSchema(breadcrumbs)];
  return <>
      <SEO title="Legal Notice" description="Legal Notice of the Close CRM Agency - Legal information and contact details." canonical="https://close-crm-agentur.de/legal-notice" noindex={true} structuredData={structuredData} data-id="element-467" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-468">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-469">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-470">
            <div className="flex items-center justify-center sm:justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-471">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0" aria-label="Close CRM Agency Homepage" data-id="element-472">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-473">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-474">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-475">
                  Close CRM Agency
                </span>
              </a>
              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-476">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-477" />
                Back to Homepage
              </a>
            </div>
          </nav>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-16" data-id="element-478">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-479">
            <div className="prose prose-invert prose-lg max-w-none" data-id="element-480">
              <h1 className="text-4xl font-bold text-white mb-8" data-id="element-481">
                Legal Notice
              </h1>

              <div className="space-y-8 text-gray-300" data-id="element-482">
                <section data-id="element-483">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-484">
                    Address
                  </h2>
                  <p className="leading-relaxed" data-id="element-485">
                    CRM Kraft LLC
                    <br data-id="element-486" />
                    2880 West Oakland Park Boulevard
                    <br data-id="element-487" />
                    33311 Florida
                    <br data-id="element-488" />
                    United States of America
                  </p>
                </section>

                <section data-id="element-489">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-490">
                    Contact
                  </h2>
                  <p className="leading-relaxed" data-id="element-491">
                    Phone:{' '}
                    <a href="tel:+4915735999071" className="text-[#0ea5e9] hover:underline" data-id="element-492">
                      +49 157 35999071
                    </a>
                    <br data-id="element-493" />
                    Email:{' '}
                    <a href="mailto:justus@crm-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-494">
                      justus@crm-kraft.de
                    </a>
                  </p>
                </section>

                <section data-id="element-495">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-496">
                    EU Dispute Resolution
                  </h2>
                  <p className="leading-relaxed" data-id="element-497">
                    The European Commission provides a platform for online
                    dispute resolution (OS):{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-498">
                      https://ec.europa.eu/consumers/odr/
                    </a>
                    . You can find our email address above in the legal notice.
                  </p>
                </section>

                <section data-id="element-499">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-500">
                    Consumer Dispute Resolution/Universal Arbitration Board
                  </h2>
                  <p className="leading-relaxed" data-id="element-501">
                    We are not willing or obliged to participate in dispute
                    resolution proceedings before a consumer arbitration board.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-502">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-503">
            <p className="text-gray-600 text-sm" data-id="element-504">
              © {new Date().getFullYear()} Close CRM Agency. All rights
              reserved.
            </p>
          </div>
        </footer>
      </div>
    </>;
}